import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitBooking = (data) => axios.post(`${API}/booking`, data);
export const submitContact = (data) => axios.post(`${API}/contact`, data);
export const loginAdmin = (email, password) => axios.post(`${API}/auth/login`, { email, password });
export const fetchInquiries = (token) =>
  axios.get(`${API}/inquiries`, { headers: { Authorization: `Bearer ${token}` } });
export const checkSetupToken = (token) => axios.get(`${API}/auth/setup/${token}`);
export const completeSetup = (token, password) => axios.post(`${API}/auth/setup`, { token, password });
